module.exports = __webpack_public_path__ + "static/media/visit-our-storage-and-find-and buy-your-vintage-design-item.4fb2b1d9.jpg";